module.exports = __webpack_public_path__ + "img/20_dice[9].db7ee784.png";